import { Outlet } from 'react-router-dom'
import Header from '../header/Header'
import '@nike/eds/dist/index.css'
import './AuthorizedLayout.css'
import { useOktaAuth } from '@okta/okta-react'
import { AuthState, toRelativeUrl } from '@okta/okta-auth-js'
import LoginError from '../../pages/LoginError'


function AuthorizedLayout({ requiredGroup }) {
    const { oktaAuth, authState } = useOktaAuth();

    const isAuthenticated = authState?.isAuthenticated;
    const isAuthorized = hasAuthorizedGroup(authState, requiredGroup);

    if (!isAuthenticated) {
        const originalUri = toRelativeUrl(window.location.href, window.location.origin);
        oktaAuth.setOriginalUri(originalUri);
        oktaAuth.signInWithRedirect();
    }

    if (!isAuthorized) {
        return (<LoginError requiredGroup={requiredGroup}/>);
    }

    return (
        <div className="container">
            <Header />
            <div className="main">
                <Outlet />
            </div>
        </div>
    )
}

function hasAuthorizedGroup(authState: AuthState | null, requiredGroup: string) {
    const groups = authState?.idToken?.claims?.groups;

    if (Array.isArray(groups)) {
        return groups.includes(requiredGroup);
    }

    return false;
}

export default AuthorizedLayout
